import { ILookupValue } from '../../model';

import { getApi } from './api';

const URL = '/industrySector';

const getLookupValues = async (): Promise<ILookupValue[]> => {
  const api = await getApi();
  return api
    .get<ILookupValue[]>(`${URL}/lookup-values`)
    .then((response) => response.data);
};

export const industrySectorsService = {
  getLookupValues,
};
